<template>
  <div class="login-page" v-title data-title="用户登录">
    <div class="login-bg">
      <!-- 与欢迎页同款：背景图 + 缓慢缩放，先本地图再轮播 -->
      <div class="login-bg-img-wrap" :style="backgroundStyle"></div>
      <!-- 霓虹色调叠加 + 动态渐变 -->
      <div class="login-bg-gradient"></div>
      <div class="login-bg-grid"></div>
      <div class="login-bg-glow login-bg-glow-1"></div>
      <div class="login-bg-glow login-bg-glow-2"></div>
      <div class="login-bg-scan"></div>
      <div class="login-overlay"></div>
    </div>

    <div class="login-card">
      <h1 class="login-title">用户登录</h1>
      <p class="login-subtitle">欢迎回来</p>
      <el-form ref="userForm" :model="userForm" :rules="rules" class="login-form">
        <el-form-item prop="phoneNumber">
          <el-input
            placeholder="用户名 / 手机号"
            v-model="userForm.phoneNumber"
            prefix-icon="el-icon-user"
            class="login-input"
          />
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            placeholder="密码"
            type="password"
            v-model="userForm.password"
            prefix-icon="el-icon-lock"
            show-password
            class="login-input"
            @keyup.enter.native="login('userForm')"
          />
        </el-form-item>
        <el-form-item class="login-submit">
          <el-button type="primary" class="login-btn" @click.native.prevent="login('userForm')">
            登 录
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      // 与欢迎页类似的背景图（本地 + 外链轮播）
      backgrounds: [
        require('../assets/img/scene.jpg'),
        'https://images.unsplash.com/photo-1519681393784-d120267933ba?w=1920&q=80',
        'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1920&q=80',
        'https://images.unsplash.com/photo-1510915228340-29c85a43dcfe?w=1920&q=80'
      ],
      currentBg: 1,
      bgTimer: null,
      userForm: {
        phoneNumber: "",
        password: "",
      },
      rules: {
        phoneNumber: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { max: 10, message: '不能大于10个字符！', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 18, message: '密码不能小于6个字符,大于18个字符', trigger: 'blur' }
        ]
      },
      // 标记是否已加载 Dify，避免重复创建脚本
      difyLoaded: false
    }
  },
  computed: {
    backgroundStyle() {
      return { backgroundImage: `url(${this.backgrounds[this.currentBg]})` };
    }
  },
  mounted() {
    this.bgTimer = setInterval(() => {
      this.currentBg = (this.currentBg + 1) % this.backgrounds.length;
    }, 8000);
    this.loadDifyLikeTestHtml();
  },
  beforeDestroy() {
    if (this.bgTimer) clearInterval(this.bgTimer);
  },
  methods: {
    login(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$store.dispatch("login", this.userForm).then(() => {
            this.$router.push({ path: "/" });
            this.$message({ message: "登录成功!", type: "success", showClose: true });
          }).catch((error) => {
            if (error !== 'error') {
              this.$message({ message: error, type: 'error', showClose: true });
            }
          })
        } else {
          return false;
        }
      });
    },

    // 核心方法：模拟测试 HTML 的方式加载 Dify（先配置、再脚本、后样式）
    loadDifyLikeTestHtml() {
      // 避免重复加载（切换路由再返回时不重复创建标签）
      if (this.difyLoaded) return;

      // 1. 第一步：添加 Dify 配置（对应测试 HTML 中的 <script> 配置块）
      const difyConfigScript = document.createElement('script');
      difyConfigScript.textContent = `
                window.difyChatbotConfig = {
                    token: 'P56NzLX0eXPfmQ8F',
                    baseUrl: 'https://dify.suqiqaq.cn'
                }
            `;
      // 配置脚本同步执行（确保先有配置，再加载脚本）
      document.head.appendChild(difyConfigScript);

      // 2. 第二步：添加 Dify 加载脚本（对应测试 HTML 中的 <script src="...">）
      const difyLoadScript = document.createElement('script');
      difyLoadScript.src = 'https://dify.suqiqaq.cn/embed.min.js';
      difyLoadScript.id = 'P56NzLX0eXPfmQ8F';
      difyLoadScript.defer = true; // 保持测试 HTML 中的 defer 属性
      // 脚本加载失败提示
      difyLoadScript.onerror = () => {
        console.error('Dify 脚本加载失败（可能是 HTTPS 拦截 HTTP 资源）');
      };
      document.head.appendChild(difyLoadScript);

      // 3. 第三步：添加 Dify 自定义样式（对应测试 HTML 中的 <style> 块）
      const difyStyle = document.createElement('style');
      difyStyle.textContent = `
                #dify-chatbot-bubble-button {
                    background-color: #1C64F2 !important;
                }
            `;
      document.head.appendChild(difyStyle);

      // 标记已加载，避免重复执行
      this.difyLoaded = true;
    }
  }
}
</script>

<style scoped>
.login-page {
  position: relative;
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.login-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

/* 与欢迎页同款：背景图 + 缓慢缩放 */
.login-bg-img-wrap {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  transition: background-image 1.5s ease-in-out;
  animation: login-bg-zoom 20s ease-in-out infinite alternate;
}

@keyframes login-bg-zoom {
  from { transform: scale(1.05); }
  to { transform: scale(1.15); }
}

/* 赛博朋克色调叠加（青/紫）+ 轻微流动 */
.login-bg-gradient {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    135deg,
    rgba(10, 15, 30, 0.75) 0%,
    rgba(0, 40, 60, 0.4) 30%,
    rgba(40, 10, 50, 0.35) 70%,
    rgba(10, 15, 30, 0.8) 100%
  );
  background-size: 200% 200%;
  animation: login-gradient 18s ease infinite;
}

@keyframes login-gradient {
  0%, 100% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
}

/* 科技网格 */
.login-bg-grid {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image:
    linear-gradient(rgba(0, 255, 245, 0.06) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 255, 245, 0.06) 1px, transparent 1px);
  background-size: 48px 48px;
  animation: login-grid 20s linear infinite;
}

@keyframes login-grid {
  0% { transform: perspective(400px) rotateX(60deg) translateY(0); }
  100% { transform: perspective(400px) rotateX(60deg) translateY(48px); }
}

/* 光晕 */
.login-bg-glow {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  opacity: 0.4;
  animation: login-glow 12s ease-in-out infinite;
}

.login-bg-glow-1 {
  width: 60vw;
  height: 60vw;
  top: -20%;
  left: -10%;
  background: radial-gradient(circle, rgba(0, 255, 245, 0.25) 0%, transparent 70%);
  animation-delay: 0s;
}

.login-bg-glow-2 {
  width: 50vw;
  height: 50vw;
  bottom: -15%;
  right: -10%;
  background: radial-gradient(circle, rgba(99, 102, 241, 0.2) 0%, transparent 70%);
  animation-delay: -6s;
}

@keyframes login-glow {
  0%, 100% { transform: scale(1) translate(0, 0); opacity: 0.35; }
  50% { transform: scale(1.15) translate(5%, 5%); opacity: 0.5; }
}

/* 扫描线纹理 */
.login-bg-scan {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: repeating-linear-gradient(
    0deg,
    transparent,
    transparent 2px,
    rgba(0, 0, 0, 0.08) 2px,
    rgba(0, 0, 0, 0.08) 4px
  );
  pointer-events: none;
  opacity: 0.8;
}

.login-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    180deg,
    rgba(10, 15, 30, 0.35) 0%,
    rgba(10, 15, 30, 0.5) 50%,
    rgba(10, 15, 30, 0.45) 100%
  );
}

/* 科技风玻璃卡片 */
.login-card {
  position: relative;
  z-index: 10;
  width: 100%;
  max-width: 420px;
  padding: 48px 40px;
  background: rgba(10, 15, 30, 0.7);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(0, 255, 245, 0.25);
  border-radius: 16px;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.4),
    0 0 24px rgba(0, 255, 245, 0.08),
    inset 0 1px 0 rgba(255, 255, 255, 0.05);
}

.login-title {
  margin: 0 0 8px;
  font-size: 26px;
  font-weight: 600;
  color: #fff;
  text-align: center;
  letter-spacing: 2px;
  text-shadow: 0 0 20px rgba(0, 255, 245, 0.3);
}

.login-subtitle {
  margin: 0 0 32px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  text-align: center;
}

.login-form >>> .el-form-item {
  margin-bottom: 24px;
}

.login-form >>> .el-form-item:last-child {
  margin-bottom: 0;
}

.login-input >>> .el-input__inner {
  height: 48px;
  padding-left: 40px;
  font-size: 15px;
  color: #fff;
  letter-spacing: 1px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(0, 255, 245, 0.2);
  border-radius: 10px;
  transition: all 0.25s ease;
}

.login-input >>> .el-input__inner::placeholder {
  color: rgba(255, 255, 255, 0.4);
}

.login-input >>> .el-input__inner:hover {
  border-color: rgba(0, 255, 245, 0.4);
  box-shadow: 0 0 12px rgba(0, 255, 245, 0.1);
}

.login-input >>> .el-input__inner:focus {
  border-color: rgba(0, 255, 245, 0.7);
  box-shadow: 0 0 16px rgba(0, 255, 245, 0.2);
  background: rgba(255, 255, 255, 0.08);
}

.login-input >>> .el-input__prefix {
  left: 14px;
}

.login-input >>> .el-input__prefix .el-input__icon {
  color: rgba(0, 255, 245, 0.6);
  font-size: 18px;
}

.login-input >>> .el-input__prefix .el-input__icon:hover {
  color: #00fff5;
}

.login-submit {
  margin-top: 32px;
  text-align: center;
}

.login-btn {
  width: 100%;
  height: 48px;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 4px;
  color: rgba(10, 15, 30, 0.95) !important;
  background: linear-gradient(135deg, #00fff5 0%, rgba(0, 255, 245, 0.85) 100%) !important;
  border: none !important;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 255, 245, 0.35);
  transition: all 0.25s ease;
}

.login-btn:hover {
  background: linear-gradient(135deg, #00fff5 0%, #00e6dc 100%) !important;
  box-shadow: 0 6px 28px rgba(0, 255, 245, 0.5);
  transform: translateY(-1px);
}
</style>